import type { TricksFile } from "../config/types";

type AirConfig = TricksFile["air"];

export interface AirState {
    height: number;
    vz: number;
    floor: number;
    time: number;
}

export const GROUNDED: AirState = { height: 0, vz: 0, floor: 0, time: 0 };

export function launchAir(vz: number, dropM = 0): AirState {
    return { height: 0, vz, floor: -dropM, time: 0 };
}

export function stepAir(air: AirState, dt: number, gravity: number): AirState {
    const vz = air.vz - gravity * dt;
    const height = Math.max(air.floor, air.height + vz * dt);
    return { ...air, vz, height, time: air.time + dt };
}

export const hasLanded = (air: AirState) => air.time > 0 && air.height <= air.floor;

export const heightAboveGround = (air: AirState) => air.height - air.floor;

export function airtime(vz: number, gravity: number, dropM = 0): number {
    return (vz + Math.sqrt(vz * vz + 2 * gravity * dropM)) / gravity;
}

export function rampLaunchVz(speed: number, scale: number, pop: boolean, cfg: AirConfig): number {
    return speed * cfg.launchPerSpeed * scale * (pop ? 1 + cfg.popBonus : 1);
}

export function dropLaunchVz(speed: number, pop: boolean, cfg: AirConfig): number {
    return rampLaunchVz(speed, cfg.dropVzFactor, pop, cfg);
}

export function isPop(secondsSincePress: number, cfg: AirConfig): boolean {
    return secondsSincePress >= 0 && secondsSincePress <= cfg.popWindowS;
}
